module.exports = __webpack_public_path__ + "static/media/copyright-page.9cbf2d59.jpg";